<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-10 11:45:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-02-10 11:45:00
 * @FilePath: \goodmanger\src\views\InfoStatistics.vue
 * @Description: 信息统计页面
-->
<template>
  <div class="info-statistics">
    <div class="page-header">
      <h2>信息统计</h2>
      <div class="date-range">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="handleDateChange"
        >
        </el-date-picker>
        <el-button type="primary" @click="handleRefresh">刷新数据</el-button>
      </div>
    </div>
    
    <!-- 核心指标卡片 -->
    <div class="stats-cards">
      <el-card class="stat-card">
        <div class="stat-item">
          <div class="stat-value">{{ totalVisits }}</div>
          <div class="stat-label">总访问量</div>
          <div class="stat-change" :class="{ 'positive': visitChange > 0, 'negative': visitChange < 0 }">
            {{ visitChange > 0 ? '+' : '' }}{{ visitChange }}%
          </div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-item">
          <div class="stat-value">{{ uniqueUsers }}</div>
          <div class="stat-label">独立用户数</div>
          <div class="stat-change" :class="{ 'positive': userChange > 0, 'negative': userChange < 0 }">
            {{ userChange > 0 ? '+' : '' }}{{ userChange }}%
          </div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-item">
          <div class="stat-value">{{ avgVisitTime }}</div>
          <div class="stat-label">平均访问时长</div>
          <div class="stat-change" :class="{ 'positive': timeChange > 0, 'negative': timeChange < 0 }">
            {{ timeChange > 0 ? '+' : '' }}{{ timeChange }}%
          </div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-item">
          <div class="stat-value">{{ bounceRate }}%</div>
          <div class="stat-label">跳出率</div>
          <div class="stat-change" :class="{ 'positive': bounceChange < 0, 'negative': bounceChange > 0 }">
            {{ bounceChange > 0 ? '+' : '' }}{{ bounceChange }}%
          </div>
        </div>
      </el-card>
    </div>
    
    <!-- 访问趋势图 -->
    <el-card class="chart-card">
      <h3>访问趋势</h3>
      <el-tabs v-model="trendType">
        <el-tab-pane label="日趋势" name="day">
          <el-table :data="dayTrendData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="100"></el-table-column>
            <el-table-column prop="visits" label="访问量" width="120"></el-table-column>
            <el-table-column prop="users" label="独立用户" width="120"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="周趋势" name="week">
          <el-table :data="weekTrendData" style="width: 100%">
            <el-table-column prop="week" label="周" width="100"></el-table-column>
            <el-table-column prop="visits" label="访问量" width="120"></el-table-column>
            <el-table-column prop="users" label="独立用户" width="120"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="月趋势" name="month">
          <el-table :data="monthTrendData" style="width: 100%">
            <el-table-column prop="month" label="月" width="100"></el-table-column>
            <el-table-column prop="visits" label="访问量" width="120"></el-table-column>
            <el-table-column prop="users" label="独立用户" width="120"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    
    <!-- 分析图表 -->
    <div class="chart-row">
      <!-- 访问来源分析 -->
      <el-card class="chart-card source-chart">
        <h3>访问来源分析</h3>
        <el-table :data="sourceData" style="width: 100%">
          <el-table-column prop="name" label="来源" width="120"></el-table-column>
          <el-table-column prop="value" label="占比(%)" width="100"></el-table-column>
          <el-table-column label="占比图示">
            <template slot-scope="scope">
              <div class="progress-container">
                <el-progress :percentage="scope.row.value" :color="getProgressColor(scope.$index)" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      
      <!-- 用户地域分布 -->
      <el-card class="chart-card region-chart">
        <h3>用户地域分布</h3>
        <el-table :data="regionData" style="width: 100%">
          <el-table-column prop="name" label="地域" width="120"></el-table-column>
          <el-table-column prop="value" label="占比(%)" width="100"></el-table-column>
          <el-table-column label="占比图示">
            <template slot-scope="scope">
              <div class="progress-container">
                <el-progress :percentage="scope.row.value" :color="getProgressColor(scope.$index)" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    
    <!-- 设备分析 -->
    <el-card class="chart-card">
      <h3>访问设备分析</h3>
      <el-table :data="deviceData" style="width: 100%">
        <el-table-column prop="device" label="设备" width="120"></el-table-column>
        <el-table-column prop="count" label="访问量" width="120"></el-table-column>
        <el-table-column label="占比图示">
          <template slot-scope="scope">
            <div class="progress-container">
              <el-progress :percentage="Math.round((scope.row.count / totalVisits) * 100)" :color="getProgressColor(scope.$index)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <!-- 热门页面 -->
    <el-card class="chart-card">
      <h3>热门页面</h3>
      <el-table :data="hotPages" style="width: 100%">
        <el-table-column prop="rank" label="排名" width="80"></el-table-column>
        <el-table-column prop="page" label="页面名称"></el-table-column>
        <el-table-column prop="visits" label="访问量" width="120"></el-table-column>
        <el-table-column prop="percentage" label="占比" width="120">
          <template slot-scope="scope">
            {{ scope.row.percentage }}%
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'InfoStatistics',
  data() {
    return {
      activeMenu: '/info-statistics',
      dateRange: ['2026-02-01', '2026-02-10'],
      trendType: 'day',
      totalVisits: 12580,
      uniqueUsers: 8920,
      avgVisitTime: '3m 45s',
      bounceRate: 32.5,
      visitChange: 12.5,
      userChange: 8.3,
      timeChange: 5.2,
      bounceChange: -2.1,
      // 日趋势数据
      dayTrendData: [
        { date: '02-01', visits: 1024, users: 756 },
        { date: '02-02', visits: 1156, users: 823 },
        { date: '02-03', visits: 987, users: 698 },
        { date: '02-04', visits: 1345, users: 921 },
        { date: '02-05', visits: 1567, users: 1056 },
        { date: '02-06', visits: 1234, users: 876 },
        { date: '02-07', visits: 1098, users: 789 },
        { date: '02-08', visits: 1456, users: 987 },
        { date: '02-09', visits: 1678, users: 1123 },
        { date: '02-10', visits: 1645, users: 1091 }
      ],
      // 周趋势数据
      weekTrendData: [
        { week: '第1周', visits: 6073, users: 4354 },
        { week: '第2周', visits: 6507, users: 4566 }
      ],
      // 月趋势数据
      monthTrendData: [
        { month: '1月', visits: 32450, users: 21890 },
        { month: '2月', visits: 12580, users: 8920 }
      ],
      // 访问来源数据
      sourceData: [
        { name: '微信搜索', value: 35 },
        { name: '好友分享', value: 25 },
        { name: '扫码进入', value: 20 },
        { name: '其他', value: 20 }
      ],
      // 地域分布数据
      regionData: [
        { name: '北京', value: 25 },
        { name: '上海', value: 20 },
        { name: '广州', value: 15 },
        { name: '深圳', value: 15 },
        { name: '其他', value: 25 }
      ],
      // 设备分析数据
      deviceData: [
        { device: 'iPhone', count: 5800 },
        { device: 'Android', count: 4200 },
        { device: 'iPad', count: 1500 },
        { device: '其他', count: 1080 }
      ],
      // 热门页面数据
      hotPages: [
        { rank: 1, page: '首页', visits: 8920, percentage: 71.0 },
        { rank: 2, page: '商品列表', visits: 6540, percentage: 52.0 },
        { rank: 3, page: '商品详情', visits: 5890, percentage: 46.8 },
        { rank: 4, page: '购物车', visits: 4230, percentage: 33.7 },
        { rank: 5, page: '订单确认', visits: 3560, percentage: 28.3 }
      ]
    };
  },
  methods: {
    handleDateChange(val) {
      console.log('日期范围变化:', val);
      // 这里可以根据选择的日期范围更新数据
    },
    handleRefresh() {
      console.log('刷新数据');
      // 这里可以添加刷新数据的逻辑
      this.$message({ type: 'success', message: '数据已刷新' });
    },
    getProgressColor(index) {
      const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399'];
      return colors[index % colors.length];
    }
  }
}
</script>

<style scoped>
.info-statistics {
  padding: 20px;
  background-color: #f5f5f5;
  height: 100%;
  overflow-y: auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
}

.date-range {
  display: flex;
  align-items: center;
}

.date-range .el-date-picker {
  margin-right: 10px;
}

.stats-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 200px;
  margin-right: 15px;
  margin-bottom: 15px;
}

.stat-card:last-child {
  margin-right: 0;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #303133;
}

.stat-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.stat-change {
  font-size: 12px;
}

.stat-change.positive {
  color: #67C23A;
}

.stat-change.negative {
  color: #F56C6C;
}

.chart-card {
  margin-bottom: 20px;
  padding: 20px;
}

.chart-card h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: bold;
}

.chart-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.source-chart, .region-chart {
  flex: 1;
  margin-right: 15px;
}

.region-chart {
  margin-right: 0;
}

@media screen and (max-width: 768px) {
  .stats-cards {
    flex-direction: column;
  }
  
  .stat-card {
    margin-right: 0;
  }
  
  .chart-row {
    flex-direction: column;
  }
  
  .source-chart, .region-chart {
    margin-right: 0;
    margin-bottom: 20px;
  }
}
</style>